import i18n from "../../i18n";

export default function calcChannels(channels) {
  let channelsColumn = "";

  let translationChannels = {
    attachEmail: i18n.t("columns.channelsRow.attachEmail"),
    linkEmail: i18n.t("columns.channelsRow.linkEmail"),
    print: i18n.t("columns.channelsRow.print"),
    noChannel: i18n.t("columns.channelsRow.noChannel"),
  };

  if (channels === undefined) return translationChannels.noChannel;
  else {
    if (channels.attachEmail)
      channelsColumn += ", " + translationChannels.attachEmail;
    if (channels.linkEmail)
      channelsColumn += ", " + translationChannels.linkEmail;
    if (channels.edi) channelsColumn += ", " + channels.edi.network;
    if (channels.print) channelsColumn += ", " + translationChannels.print;
  }

  if (channelsColumn.trim() === "") return translationChannels.noChannel;
  channelsColumn = channelsColumn.slice(2);
  return channelsColumn;
}
